import { useState } from "react";
import { DatePicker, Button, Space, message } from "antd";
import dayjs from "dayjs";
import { downloadReportApi } from "../apis/downloadReport";

function DownloadReport() {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleDownload = () => {
    if (!fromDate || !toDate) {
      message.error("Please select both From Date and To Date");
      return;
    }
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const formData = new FormData();
    formData.append("fromDate", dayjs(fromDate).format("YYYY-MM-DD"));
    formData.append("toDate", dayjs(toDate).format("YYYY-MM-DD"));
    if (currentUser?.role === "CLUSTER_LEADER") {
      formData.append("clusterLeaderId", currentUser?.supervisorId)
    }
    

    downloadReportApi(formData)
      .then((res) => {
        const blob = new Blob([res], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        const fileName = "attendance.csv";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        console.error("CSV download failed:", err);
        message.error("Failed to download report.");
      });
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Download Attendance Report</h2>
      <Space direction="horizontal" style={{ marginBottom: "16px" }}>
        <DatePicker onChange={(date) => setFromDate(date)} placeholder="From Date" />
        <DatePicker onChange={(date) => setToDate(date)} placeholder="To Date" />
        <Button type="primary" onClick={handleDownload}>
          Download CSV
        </Button>
      </Space>
    </div>
  );
}

export default DownloadReport;
